import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { getTimelines } from 'redux/actions/timelineActions';
import LoadingOverlay from 'components/LoadingOverlay';
import CampaignTab from 'components/timeline/CampaignTab';
import SequenceTab from 'components/timeline/SequenceTab';
import NoReportTab from 'components/timeline/NoReportTab';


const TimelineList = ({ timelines, ...props }) => {
  useEffect(() => {
    props.getTimelines();
  }, []);
  const [selectedCampaign, openCampaign] = useState(null);
  return (
    <Card>
      <CardContent>
        <LoadingOverlay loading={timelines.loading} />
        {isEmpty(timelines.results) ?
          <NoReportTab />
          :
          <>
            {selectedCampaign ?
              <SequenceTab campaign={selectedCampaign} onBack={() => openCampaign(null)} />
              :
              <CampaignTab openCampaign={openCampaign} />
            }
          </>
        }
      </CardContent>
    </Card>
  );
};

TimelineList.propTypes = {
  getTimelines: PropTypes.func.isRequired,
  timelines: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    results: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

TimelineList.defaultProps = {
  timelines: {
    loading: false,
    loaded: true,
    results: [],
  },
};

export default compose(connect(state => ({
  timelines: state.timelines,
}), { getTimelines }))(TimelineList);
